
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled':isMigrationActive}">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Edit Shipping Labels</p>
      </div>
    </div>
  </div>
  <form #projectForm="ngForm">
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="row">
          <div class="form-group col-lg-12">
            <label for="shippingLabel1">Shipping Label 1</label>
            <div class="input-group">
              <input class="form-control" id="shippingLabel1" [(ngModel)]="shippingLabel1" name="shippingLabel1" (focus)="onFocus('shippingLabel1')" type="text">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-12">
            <label for="shippingLabel2">Shipping Label 2</label>
            <div class="input-group">
              <input class="form-control" id="shippingLabel2" [(ngModel)]="shippingLabel2" name="shippingLabel2" (focus)="onFocus('shippingLabel2')" type="text">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-12"><span>Shipping Label 1 and 2 must either be both blank, or both set.</span><br><span>All placeholders must be exact including case and include no extra space.</span><br><span>Example:  Attn. &#123;FirstName} &#123;LastName} #&#123;MailStop}</span></div>
          <div class="form-group col-lg-12"><span>The following placeholders can be used in your shipping labels:</span></div>
        </div>
        <div class="row">
          <div class="form-group col-lg-12">
            <ul>
              <li *ngFor="let placeholder of placeholders"><span style="font-weight:bold">{{ placeholder.name }} &nbsp;&nbsp;</span><a href="javascript:void(0);" (click)="addPlaceholder(placeholder.name)">(add)</a><span>&nbsp;{{ placeholder.description }}</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>